import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../take-until-destroy.decorator';

/* TODO move to uikit */
@Directive({
    selector: 'input[cmpsUikSearchInput]',
    host: {
        '[value]': "keyword ?? ''",
        '(input)': '_onKeywordFilterChange($event)',
        '(keydown.enter)':
            '$event.preventDefault(); _dispatchFilterKeyword(searchInputRef.value)',
    },
})
@TakeUntilDestroy()
export class SearchInputDirective implements OnInit, OnDestroy {
    @Input() keyword: string;
    @Output() keywordChange: EventEmitter<string>;

    private _keywordSubj: Subject<string>;
    private _keywordSub: Subscription;

    constructor(private readonly _el: ElementRef<HTMLInputElement>) {
        this.keywordChange = new EventEmitter();
    }

    ngOnInit(): void {
        this._initKeyword();
        this._el.nativeElement?.focus();
    }

    ngOnDestroy(): void {
        this._keywordSub?.unsubscribe();
        this._keywordSubj?.complete();

        this.keywordChange.complete();
    }

    /** @private */
    _onKeywordFilterChange(): void {
        this._keywordSubj.next(this._el.nativeElement?.value);
    }

    /** @private */
    _dispatchFilterKeyword(keyword: string): void {
        this.keywordChange.emit(keyword);
    }

    private _initKeyword(): void {
        this._keywordSubj = new Subject();
        this._keywordSub = this._keywordSubj
            .asObservable()
            .pipe(
                debounceTime(500),
                tap((keyword) => {
                    this._dispatchFilterKeyword(keyword);
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
